import { object, null as zNull } from "zod/v4";

export const disconnectWayfairIntegration = {
  name: "disconnectWayfairIntegration" as const,
  input: object({}),
  output: zNull(),
};
